import { Reveal } from "./Reveal";
import { Chapter } from "./Chapter";
import { useContent } from "@/lib/content";

const BIO_IMAGE =
  "https://images.unsplash.com/photo-1723396612574-961649793bb9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxmaWxtJTIwc2V0JTIwY2xhcHBlcmJvYXJkJTIwY2luZW1hdGljfGVufDB8fHx8MTc4NzQzNzcyNnww&ixlib=rb-4.1.0&q=85";

export const About = () => {
  const { bio, chapters, colors } = useContent();
  return (
  <section className="mx-auto max-w-7xl px-6 md:px-12 pt-32 md:pt-44 pb-16 md:pb-20" data-testid="about-section">
    <Chapter number="01" kicker={chapters.about.kicker} title={chapters.about.title} id="about" />
    <div className="mt-20 grid lg:grid-cols-12 gap-16 items-start">
      <div className="lg:col-span-7 space-y-8">
        <Reveal>
          <p className="font-serif text-2xl md:text-3xl leading-snug text-burgundy font-light" data-testid="about-lead">
            {bio.lead}
          </p>
        </Reveal>
        {(bio.paragraphs || "").split(/\n\s*\n/).filter(Boolean).map((p, i) => (
          <Reveal key={i} delay={0.1 + i * 0.05}>
            <p className="text-base md:text-lg leading-relaxed text-charcoal/80 max-w-xl" data-testid={`about-paragraph-${i}`}>
              {p}
            </p>
          </Reveal>
        ))}
        <Reveal delay={0.2}>
          <div className="flex flex-wrap gap-x-10 gap-y-4 pt-4">
            {(bio.tags || []).map((raw, i) => {
              const t = typeof raw === "string" ? { text: raw } : raw;
              const cls = `flex items-center gap-3 text-[11px] uppercase tracking-[0.25em] text-burgundy${t.underline ? " underline decoration-1 underline-offset-2" : ""}`;
              const inner = (
                <>
                  <span className="h-1.5 w-1.5 rounded-full shrink-0" style={{ backgroundColor: colors.bullet }} />
                  {t.text}
                </>
              );
              return t.url ? (
                <a key={i} href={t.url} target="_blank" rel="noopener noreferrer" className={`${cls} hover:text-rose transition-colors`} data-testid={`about-tag-${i}`}>
                  {inner}
                </a>
              ) : (
                <span key={i} className={cls} data-testid={`about-tag-${i}`}>
                  {inner}
                </span>
              );
            })}
          </div>
        </Reveal>
      </div>
      <div className="lg:col-span-5 relative">
        <Reveal delay={0.2} y={60}>
          <div className="relative ml-auto w-4/5">
            <div aria-hidden="true" className="absolute -inset-3 border border-champagne -translate-x-4 translate-y-4" />
            <img
              src={BIO_IMAGE}
              alt="Cinematic film set still"
              data-testid="about-bio-image"
              className="relative w-full aspect-[4/5] object-cover"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
  );
};
